import _URL from '../URL/index';
const axios = _URL.axios;
const limit = 15

export default {
    services: {
        getUsers: async (limit, page, query, token) => {
            return await axios(token).get(`/users?limit=${limit}&page=${page}${query ? `&${query}` : ""}`);
        },
        newUser: (body, token) => {
            return axios(token).post(`/users`, body);
        },
        getOneUser: (_id, token) => {
            return axios(token).get(`/users/${_id}`);
        },
        deleteUser: (_id, token) => {
            return axios(token).delete(`/users/${_id}`);
        },
        updateUser: (_id, body, token) => {
            return axios(token).put(`/users/${_id}`, body);
        },
        updateSameAttribute: (_id, body, token) => {
            return axios(token).patch(`/users/${_id}`, body);
        },
        deleteUsersMany: (body, token) => {
            return axios(token).put(`/users/delete/many`, body)
        }
    }
}